import { Helmet } from 'react-helmet-async'
import { useAuth } from '@/contexts/auth-context'
import { useAuthActions } from '@convex-dev/auth/react'
import { useNavigate } from 'react-router-dom'
import { isElectron } from '@/lib/electron'

import { Navbar } from '@/components/homepage/sections/Navbar'
import { SectionHeader } from '@/components/homepage/ui/SectionHeader'
import { Pricing } from '@/components/homepage/sections/Pricing'
import { FAQ } from '@/components/homepage/sections/FAQ'
import { CTA } from '@/components/homepage/sections/CTA'
import { HomepageFooter } from '@/components/homepage/sections/HomepageFooter'
import { OG_IMAGE_URL, siteUrl } from '@/lib/config/site'

export default function PricingPage() {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuth()
  const { signIn } = useAuthActions()
  const handleSignUp = () => {
    if (isElectron()) {
      navigate('/signup')
      return
    }
    signIn('google', { redirectTo: `${window.location.origin}/auth` })
  }

  return (
    <div className="min-h-screen bg-background px-4 lg:px-0 overflow-x-hidden">
      <Helmet>
        <title>Plans and Pricing - Footage</title>
        <meta name="description" content="Simple pricing for creators and professionals. Get started free, upgrade anytime." />
        <link rel="canonical" href={siteUrl('/pricing')} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Plans and Pricing - Footage" />
        <meta property="og:description" content="Simple pricing for creators and professionals. Get started free, upgrade anytime." />
        <meta property="og:url" content={siteUrl('/pricing')} />
        <meta property="og:image" content={OG_IMAGE_URL} />
        <meta property="og:site_name" content="Footage" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Plans and Pricing - Footage" />
        <meta name="twitter:description" content="Simple pricing for creators and professionals. Get started free, upgrade anytime." />
        <meta name="twitter:image" content={OG_IMAGE_URL} />
      </Helmet>

      <div className="max-w-7xl mx-auto border-x border-border">
        <Navbar isAuthenticated={isAuthenticated} onSignUp={handleSignUp} />
        <main className="flex flex-col divide-y divide-border pt-16">
          <SectionHeader>
            <div className="flex flex-col items-center justify-center gap-4 mt-4">
              <h1 className="text-3xl md:text-4xl lg:text-6xl font-medium tracking-tighter text-center text-balance">
                Plans and Pricing
              </h1>
              <p className="text-muted-foreground md:text-lg text-center text-balance mx-auto">
                Simple, clear pricing for creators and professionals. Host, share, and publish — all in one place.
              </p>
            </div>
          </SectionHeader>
          <Pricing isAuthenticated={isAuthenticated} />
          <FAQ />
          <CTA onSignUp={handleSignUp} />
          <HomepageFooter />
        </main>
      </div>
    </div>
  )
}
